module.exports = __webpack_public_path__ + "static/media/users.075ef01b.svg";